mutation PayCycleDelete($input: PayCycleDeleteInput!) {
  payCycleDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
